import AIPortfolio from './components/AIPortfolio'

function App() {
  return <AIPortfolio />
}

export default App